import { styled, TableCell } from "@mui/material";

export const ExplainerTableCell = styled(TableCell)({
  padding: "12px 25px",
  maxWidth: "200px",
});
